<template>
  <Expandable
    class="mb-4 rounded-md border shadow-lg"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #expandable-title>
      <BaseIcon
        icon="book"
        class="mr-4 text-gray-500"
      />
      <div class="pr-2 flex-1 text-left color-deep-black font-semibold text-lg md:text-xl leading-5 md:leading-6">{{ value.degreeMapName || 'Untitled Degree Map' }}</div>
    </template>
    <template #expandable-content>
      <div class="border-t">
        <div
          v-if="isFieldVisible(fields.degreeMapNarrative)"
          class="p-4 mx-4 mt-4 bg-gray-100 rounded"
        >
          <label class="font-medium">{{ fields.degreeMapNarrative.label }}</label>
          <RichContent
            :content="value.degreeMapNarrative"
            class="main-content"
          />
        </div>
        <ExpandableController :expanded="$attrs.expanded">
          <template #expand-button><span /></template>
          <template #default="{ expandables:expandablesYear, trackToggle:trackToggleYear }">
            <Expandable
              v-for="(year, yIndex) in Object.keys(degreeMapYearsObject)"
              :key="`${year}${yIndex}`"
              class="border-b last:border-b-0"
              v-bind="$attrs"
              :expandable-id="`${year}${yIndex}`"
              :expanded="`${year}${yIndex}` in expandablesYear ? expandablesYear[`${year}${yIndex}`] : $attrs.expanded"
              @toggle="trackToggleYear({ expandableId: `${year}${yIndex}`, expandableStatus: $event })"
            >
              <template #expandable-title>
                <div class="pr-2 flex-1 text-left font-semibold">{{ year }}</div>
              </template>
              <template #expandable-content="{ expanded: expandedYear }">
                <ExpandableController :expanded="expandedYear">
                  <template #expand-button><span /></template>
                  <template #default="{ expandables:expandablesSemester, trackToggle:trackToggleSemester }">
                    <Expandable
                      v-for="(semester, sIndex) in degreeMapYearsObject[year]"
                      :key="`${semester.semester}${sIndex}`"
                      class="rounded mx-4 mb-4 border border-gray-200"
                      v-bind="$attrs"
                      :expandable-id="`${semester.semester}${sIndex}`"
                      :expanded="`${semester.semester}${sIndex}` in expandablesSemester ? expandablesSemester[`${semester.semester}${sIndex}`] : expandedYear"
                      @toggle="trackToggleSemester({ expandableId: `${semester.semester}${sIndex}`, expandableStatus: $event })"
                    >
                      <template #expandable-title>
                        <BaseIcon
                          icon="calendar-alt"
                          class="mr-4 text-gray-500"
                        />
                        <span class="font-semibold">{{ semester.semester }}</span>
                      </template>
                      <template #expandable-content>
                        <div class="px-4 pb-2">
                          <DegreeMapSemesterInfo
                            class="mb-4"
                            :semester="semester"
                            :all-requirements="allRequirements"
                            :document-value="documentValue"
                            :config="config"
                            :terms="terms"
                            :semester-names="semesterNames"
                            :courses="courses"
                            :course-sets="courseSets"
                          />
                          <strong class="mb-2 block">Requirements</strong>
                          <DegreeMapRequirements
                            :config="config"
                            :courses="courses"
                            :course-sets="courseSets"
                            :requirements="semester.requirements"
                          />
                        </div>
                      </template>
                    </Expandable>
                  </template>
                </ExpandableController>
              </template>
            </Expandable>
          </template>
        </ExpandableController>
      </div>
    </template>
  </Expandable>
</template>

<script>
import DegreeMapSemesterInfo from './DegreeMapSemesterInfo'
import DegreeMapRequirements from './DegreeMapRequirements'
import Expandable from '@/components/Expandable'
import ExpandableController from '@/components/ExpandableController'
import RichContent from '@/components/RichContent'

export default {
  components: {
    DegreeMapSemesterInfo,
    DegreeMapRequirements,
    Expandable,
    ExpandableController,
    RichContent,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    documentValue: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    courses: {
      type: Array,
      default: () => [],
    },
    courseSets: {
      type: Array,
      default: () => [],
    },
    terms: {
      type: Array,
      default: () => [],
    },
    semesterNames: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    degreeMapYearsObject() {
      return (this.value.semesters || []).reduce((acc, semester) => {
        if (!acc[semester.year]) acc[semester.year] = []
        acc[semester.year].push(semester)
        return acc
      }, {})
    },
    allRequirements() {
      return (this.value.semesters || []).reduce((acc, sem) => {
        acc.push(...sem.requirements)
        return acc
      }, [])
    },
    fields() {
      return this.config.fields
    },
  },
  methods:{
    isFieldVisible(field) {
      return field && field?.hidden !== true
    },
  }
}
</script>
